import { canUseDOM } from 'exenv';
import {
  SHOP_COMPONENTS_VERSION_READY_EVENT,
  setLastKnownShopComponentsVersion,
} from '@nike/shop-apis/query-cache/shop-components-version';

const SHOP_COMPONENTS_VERSION = process.env.PACKAGE_VERSION;

const exposeShopComponentsVersion = () => {
  Object.defineProperty(window, 'NikeShopClientVersion', {
    value: SHOP_COMPONENTS_VERSION,
    configurable: true,
  });
  setLastKnownShopComponentsVersion({ version: SHOP_COMPONENTS_VERSION });
  window.dispatchEvent(new Event(SHOP_COMPONENTS_VERSION_READY_EVENT));
};

/**
 * @private
 * @ignore
 * lazy loads bootstrapNikeShop, invokes it and defines NikeShop as a global property on window with the created instance
 *
 * @returns {Promise} a dynamic import promise that code splits the bigger chunks from the entry file, resolving the new NikeShop instance
 */
async function init(...args) {
  const { default: bootstrapNikeShop } = await import(
    /* webpackChunkName: "bootstrap-nike-shop" */ './bootstrap-nike-shop.js'
  );
  if (window.NikeShop === undefined) {
    bootstrapNikeShop(...args);

    // NOTE - we are moving the tagging up here to avoid changing hash for bigger file
    Object.defineProperty(window.NikeShop, 'version', { value: SHOP_COMPONENTS_VERSION });
  }
  return window.NikeShop;
}

/**
 * @private
 * @ignore
 * defines initNikeShop as a global property on window
 */
export default function initNikeShop() {
  if (canUseDOM) {
    exposeShopComponentsVersion();

    if (window.initNikeShop === undefined) {
      Object.defineProperty(window, 'initNikeShop', { value: init });
    }
  }
}
